import React from "react";
import { Checkbox } from "../../ui/checkbox";

export function CheckboxField({
  item,
  value,
  error,
  helperText,
  disabled,
  onCheckedChange,
  className,
  labelClassName
}) {
  return (
    <div className="flex flex-col space-y-2">
      <Checkbox
        id={item.id}
        checked={value || false}
        onCheckedChange={onCheckedChange}
        disabled={disabled}
        error={error}
        label={item.label}
        errorMessage={error ? helperText : undefined}
        className={className}
        labelClassName={labelClassName}
      />
    </div>
  );
}
